import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ToasterMessageModel } from "../models/toaster-message.model";

@Injectable({
  providedIn: "root",
})
export class ToasterMessageService {
  initialMessage: ToasterMessageModel = {
    severity: "severity",
    summary: "success",
    detail: "detail",
    timeout: 5000,
  };
  private readonly messageSubject = new BehaviorSubject<ToasterMessageModel>(this.initialMessage);
  public message$: Observable<ToasterMessageModel> = this.messageSubject.asObservable();

  sendMessage(message: ToasterMessageModel) {
    this.messageSubject.next(message);
  }
}
